import React, { useState, useEffect } from 'react';
import ReactGA from 'react-ga';
import Box from '@mui/material/Box';
import { connect } from 'react-redux';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import { Grid, Icon, Paper, Typography } from '@mui/material/';
import { OutlinedInput } from '@mui/material/';
import toast from 'react-hot-toast';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';

import { initializeApp } from 'firebase/app';
import {
  initializeAuth,
  browserLocalPersistence,
  browserPopupRedirectResolver,
  indexedDBLocalPersistence,
  getRedirectResult,
  signInWithRedirect,
  GoogleAuthProvider,
  FacebookAuthProvider,
  TwitterAuthProvider,
} from 'firebase/auth';

import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormHelperText from '@mui/material/FormHelperText';
import { red } from '@mui/material/colors';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

import TokenManager from '../../utils/tokenManager';
import {
  signupUser,
  signupFirebaseUser,
  resetErrorsDispatch,
  sendSignupOTP,
  sendSignupMobileOTP,
  dispatchSetOccupation,
  signupUserWithMobile,
  dispatchRegisterType,
} from '../../store/actions/register';
import { fetchInitVars } from '../../store/actions/common';
import {
  loginFirebaseUser,
  dispatchDestroySession,
} from '../../store/actions/auth';
import { firebaseConfig } from '../../configs/firebaseConfig';

import { emailRegEx, passwordRegEx } from '../../constants/regex';
import * as ROUTES from '../../constants/routes';
import { SocialMediaButton } from '../../components/Buttons/firebaseButtons';
import { ColoredButton } from '../../components/Buttons/colored';
import background from '../../assets/images/football-field_optimized.jpg';
import GoogleSVGIcon from '../../assets/images/Google_SVG.svg';
import FacebookSVGIcon from '../../assets/images/Facebook_SVG.svg';
import TwitterSVGIcon from '../../assets/images/Twitter_SVG.svg';
import { useTheme } from '@mui/material/styles';
import { siteRoles } from '../../constants/common';
import PhoneNumberInput from '../../components/PhoneNumberInput';

import 'react-phone-number-input/style.css';

const classes = (theme) => ({
  root: {
    height: 'calc(100vh - 2rem)',
    overflow: 'scroll',
    background: 'white',
  },
  formWrapper: {
    maxWidth: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '0px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      height: 'calc(100vh - 2rem)',
    },
  },
  formImage: {
    width: '70%',
    background: `url(${background}) no-repeat center`,
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  logo: {
    background: `url(https://assets.globaltalent.pro/img/logo-3d.webp) no-repeat center`,
    backgroundSize: 'contain',
    margin: '0 16px',
    width: '70%',
    height: '30%',
    [theme.breakpoints.down('sm')]: {
      width: '50%',
      height: '200px',
    },
  },
  brandName: {
    color: '#fff',
    fontSize: '36px',
    fontFamily: 'IntegralCF-Bold',
    textAlign: 'center',
    lineHeight: '1.2',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  formContentsWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'start',
    },
  },
  formContents: {
    width: '100%',
    maxWidth: '300px',
    margin: '80px 32px',
    [theme.breakpoints.down('sm')]: {
      margin: '0 24px',
    },
  },
  formTitleWrapper: {
    color: '#4e4e7e',
    textAlign: 'center',
  },
  signUpForm: {
    marginBottom: '32px',
  },
  socialMediaSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    marginBottom: '32px',
  },
  socialMediaSignUp: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '16px 0',
  },
  border: {
    borderBottom: '0.5px solid #bbb',
    width: '25%',
  },
  content: {
    width: '100%',
    color: '#888',
    textAlign: 'center',
  },
  signInButton: {
    borderRadius: '20px',
  },
  inputLabels: {
    fontWeight: '600',
    fontSize: '1em',
    marginBottom: '4px',
    color: '#00aaa5',
  },
});

const pwdText =
  'Password must have one alphabet, one number or one special character and should be 6 characters or more';
const emailText = `We'll send you a verification code, make sure you have access to the email, else you wont be able to proceed`;
const mobileText = `We'll send you a verification code, make sure you have access to the phone, else you wont be able to proceed`;

const app = initializeApp(firebaseConfig);
// Initialize Firebase Authentication and get a reference to the service
const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence],
});

const SignUpPage = (props) => {
  const theme = useTheme();
  const [signUpMessage, setSignUpMessage] = useState(
    'Join the ecosystem of sports!',
  );
  const [signUpMessageTwo, setSignUpMessageTwo] = useState('Sign up using');
  const [loadingSignupButton, setLoadingSignupButton] = useState(false);

  useEffect(() => {
    ReactGA.pageview('/signup');

    getRedirectResult(auth, browserPopupRedirectResolver)
      .then((result) => {
        if (
          result &&
          result.user &&
          window.location.pathname === ROUTES.SIGN_UP
        ) {
          TokenManager.setIdToken(
            auth.currentUser.toJSON().stsTokenManager.accessToken,
          );
          props.signupFirebaseUser(props.referer).then((resp) => {
            if (resp === 'REGISTRATION_EMAIL_ALREADY_EXISTS') {
              toast.success('Already registered! Will log you in.');
              setSignUpMessage('Already registered!');
              setSignUpMessageTwo('Will log you in...');
              TokenManager.setIdToken(
                auth.currentUser.toJSON().stsTokenManager.accessToken,
              );
              props
                .loginFirebaseUser()
                .then(() => props.history.push(ROUTES.HOME));
            } else if (resp === 'REGISTRATION_EMAIL_MISSING') {
              toast.error(
                'Email not found in your social-account. Use another way/social-account to signup.',
              );
              props.dispatchDestroySession();
            } else {
              props.history.push(ROUTES.SIGN_UP_ONBOARD_LANDING_FIREBASE);
            }
          });
        }
      })
      .catch(function (error) {
        console.log('signup error', error);
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The auth.AuthCredential type that was used.
        var credential = error.credential;
        if (errorCode === 'auth/account-exists-with-different-credential') {
          alert(
            'You have already signed up with a different auth provider for that email.',
          );
          // If you are using multiple auth providers on your app you should handle linking
          // the user's accounts here.
        } else {
          console.error(errorCode);
          console.error(error);
        }
        props.dispatchRegisterType(null);
      });
  }, []);

  useEffect(() => {
    if (props.signinWith != null) {
      setSignUpMessage(`Signing you up with ${props.signupWith}`);
      setSignUpMessageTwo('Just a moment!');
      setLoadingSignupButton(true);
    } else {
      setSignUpMessage('Join the ecosystem of sports!');
      setSignUpMessageTwo('Sign up using');
      setLoadingSignupButton(false);
    }
  }, [props.signupWith]);

  //https://dmitripavlutin.com/react-useeffect-explanation/
  useEffect(() => {
    if (!props.initVars || props.initVars === null) {
      props.fetchInitVars();
    }
  }, [props.initVars]);

  useEffect(() => {
    //this user already exists, we sign this user in
    if (
      auth.currentUser &&
      props.signupError &&
      props.signupError.email === 'REGISTRATION_EMAIL_ALREADY_EXISTS' &&
      window.location.pathname === ROUTES.SIGN_UP
    ) {
      setSignUpMessage('Already registered!');
      setSignUpMessageTwo('Will log you in');
      TokenManager.setIdToken(
        auth.currentUser.toJSON().stsTokenManager.accessToken,
      );
      props
        .loginFirebaseUser()
        .then(() =>
          props.history.push(ROUTES.SIGN_UP_ONBOARD_LANDING_FIREBASE),
        );
    }
  }, [props.signupError]);

  const haveAccount = 'Already have an account? ';
  return (
    <Box sx={classes(theme).root}>
      <Paper elevation={0} sx={classes(theme).formWrapper}>
        <Box sx={classes(theme).formImage}>
          <Box sx={classes(theme).logo} />
          <Typography sx={classes(theme).brandName}>Global Talent</Typography>
        </Box>
        <Box sx={classes(theme).formContentsWrapper}>
          <Box sx={classes(theme).formContents}>
            <Grid container justifyContent="center">
              <Grid item xs={12}>
                <Box sx={classes(theme).formTitleWrapper}>
                  <Typography variant="h4" fontWeight={700} mb={1} pb={0}>
                    {signUpMessage}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} mb={2}>
                <FormControl variant="outlined">
                  <InputLabel id="occupation-label">
                    {'You are signing up as'}
                  </InputLabel>
                  <Select
                    fullWidth
                    size="small"
                    name="first"
                    value={props.occupation}
                    onChange={(e) => {
                      props.dispatchDestroySession();
                      props.dispatchSetOccupation(e.target.value);
                    }}
                    placeholder={'You are signing up as'}
                    label={'You are signing up as'}
                  >
                    {siteRoles.map((x, i) => (
                      <MenuItem size="small" key={`o_${i}`} value={x.value}>
                        {x.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Box sx={classes(theme).formTitleWrapper} mb={2}>
                  <Typography
                    style={{
                      lineHeight: '1',
                      fontWeight: '600',
                    }}
                  >
                    {signUpMessageTwo}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={classes(theme).socialMediaSignUp}>
                  <SignUpGoogle {...props} auth={auth} />
                  <SignUpFacebook {...props} auth={auth} />
                  {/*<SignInTwitter {...props} auth={auth} />*/}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={classes(theme).container}>
                  <Box sx={classes(theme).border} />
                  <Box variant="span" sx={classes(theme).content}>
                    <Typography variant="p">
                      {'Or sign up with email/mobile'}
                    </Typography>
                  </Box>
                  <Box sx={classes(theme).border} />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={classes(theme).signUpForm}>
                  <SignUpForm
                    occupation={props.occupation}
                    loadingSignupButton={loadingSignupButton}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    textAlign: 'center',
                  }}
                >
                  {haveAccount}
                  <span>
                    <Link
                      underline="hover"
                      component={RouterLink}
                      to={{
                        pathname: ROUTES.SIGN_IN,
                        state: { from: props.location },
                      }}
                    >
                      {'Log In'}
                    </Link>
                  </span>
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

const SignUpFormBase = (props) => {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [error, setError] = useState({});
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [useMobile, setUseMobile] = useState(false);
  const [showPasswordText, setShowPasswordText] = useState(false);
  const [showEmailText, setShowEmailText] = useState(false);
  const [showMobileText, setShowMobileText] = useState(false);

  const [colorOne, setColorOne] = useState('primary');
  const [colorTwo, setColorTwo] = useState('primary');
  const [colorThree, setColorThree] = useState('primary');
  const [colorFour, setColorFour] = useState('primary');

  useEffect(() => {
    setLoading(props.loadingLoginButton);
  }, [props.loadingSignupButton]);

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    if (!useMobile) {
      if (!emailRegEx.test(email)) {
        setError({ message: 'Invalid email' });
        toast.error('Invalid email');
        setLoading(false);
      } else if (!passwordRegEx.test(password)) {
        toast.error(pwdText);
        setLoading(false);
      } else {
        props.dispatchRegisterType('Email');
        props
          .signupUser(firstname, lastname, email, password, props.referer)
          .then(async () => {
            props.resetErrorsDispatch();
            setLoading(false);
          });
      }
    } else {
      if (!passwordRegEx.test(password)) {
        toast.error(pwdText);
        setLoading(false);
      } else {
        props.dispatchRegisterType('Mobile');
        props
          .signupUserWithMobile(
            firstname,
            lastname,
            mobile,
            password,
            props.referer,
          )
          .then(async () => {
            props.resetErrorsDispatch();
            setLoading(false);
          });
      }
    }
  };

  useEffect(() => {
    if (mobile && isValidPhoneNumber(mobile)) {
      setShowMobileText(true);
    }
  }, [mobile]);

  useEffect(async () => {
    setLoading(false);
    if (
      props.signupError &&
      props.signupError.email === 'REGISTRATION_EMAIL_ALREADY_EXISTS'
    ) {
      toast.error('This email already exists, taking you to login screen');
      setTimeout(() => {
        props.resetErrorsDispatch();
        props.history.push(ROUTES.SIGN_IN);
      }, 2500);
    } else if (
      props.signupError &&
      props.signupError.mobile === 'REGISTRATION_MOBILE_ALREADY_EXISTS'
    ) {
      toast.error('This mobile already exists, taking you to login screen');
      setTimeout(() => {
        props.resetErrorsDispatch();
        props.history.push(ROUTES.SIGN_IN);
      }, 2500);
    } else if (
      props.email &&
      props.signupError &&
      props.signupError.email === 'REGISTRATION_EMAIL_ALREADY_EXISTS_INACTIVE'
    ) {
      toast.error('This email is registered, taking you to OTP screen');
      // resend OTP
      props.email &&
        props.sendSignupOTP(props.email).then(async () => {
          props.resetErrorsDispatch();
          props.history.push(ROUTES.SIGN_UP_OTP);
        });
    } else if (
      props.signupError &&
      props.signupError.email === 'REGISTRATION_EMAIL_INVALID'
    ) {
      toast.error(
        'This email is invalid, try another email. Or try with mobile number',
      );
    } else if (
      props.mobile &&
      props.signupError &&
      props.signupError.mobile === 'REGISTRATION_MOBILE_ALREADY_EXISTS_INACTIVE'
    ) {
      toast.error('This mobile is registered, taking you to OTP screen');
      // resend OTP
      props.mobile &&
        props.sendSignupMobileOTP(props.mobile).then(async () => {
          props.resetErrorsDispatch();
          props.history.push(ROUTES.SIGN_UP_OTP);
        });
    } else if (props.email && !props.signupError) {
      // set occupation here
      props.history.push(ROUTES.SIGN_UP_OTP);
    } else if (props.mobile && !props.signupError) {
      // set occupation here
      props.history.push(ROUTES.SIGN_UP_OTP);
    }
  }, [props.signupError, props.email, props.mobile]);

  useEffect(() => {
    setColorOne('primary');
    setColorTwo('primary');
    setColorThree('primary');
    setColorFour('primary');
    if (/[A-Z]+/.test(password)) setColorOne('green');
    if (/[a-z]+/.test(password)) setColorTwo('green');
    if (/[\d.!@#$%^&*()\-_]+/.test(password)) setColorThree('green');
    if (password.length > 6) setColorFour('green');
  }, [password]);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const isInvalid = useMobile
    ? password === '' ||
      mobile === '' ||
      !isValidPhoneNumber(mobile) ||
      firstname === '' ||
      lastname === ''
    : password === '' || email === '' || firstname === '' || lastname === '';

  return (
    <Box component="form" noValidate onSubmit={onSubmit}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <OutlinedInput
            fullWidth
            size="small"
            name="firstname"
            placeholder="Firstname"
            value={firstname}
            onChange={(e) => setFirstname(e.target.value)}
            type="text"
          />
          {props.signupError && !!props.signupError.firstname && (
            <FormHelperText id="firstname-text">
              {props.signupError.firstname}
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={12}>
          <OutlinedInput
            fullWidth
            size="small"
            name="lastname"
            placeholder="Lastname"
            value={lastname}
            onChange={(e) => setLastname(e.target.value)}
            type="text"
          />
          {props.signupError && !!props.signupError.lastname && (
            <FormHelperText id="lastname-text">
              {props.signupError.lastname}
            </FormHelperText>
          )}
        </Grid>
        {!useMobile && (
          <Grid item xs={12}>
            <OutlinedInput
              fullWidth
              size="small"
              name="email"
              placeholder="Email"
              value={email}
              onChange={(e) => {
                setShowEmailText(true);
                setEmail(e.target.value.trim());
              }}
              type="text"
            />
            {props.signupError && !!props.signupError.email && (
              <FormHelperText id="email-text">
                {props.signupError.email}
              </FormHelperText>
            )}
            {showEmailText && (
              <Typography
                variant="caption"
                display="block"
                color={'primary'}
                gutterBottom
              >
                {emailText}
              </Typography>
            )}
          </Grid>
        )}
        {useMobile && (
          <Grid item xs={12}>
            <PhoneInput
              international
              countryCallingCodeEditable={false}
              inputComponent={PhoneNumberInput}
              value={mobile}
              defaultCountry={
                props.initVars ? props.initVars.country_code : null
              }
              onChange={setMobile}
            />
            {showMobileText && (
              <Typography
                variant="caption"
                display="block"
                color={'primary'}
                gutterBottom
              >
                {mobileText}
              </Typography>
            )}
          </Grid>
        )}
        <Grid item xs={12}>
          <Typography
            variant="subtitle2"
            sx={{ textAlign: 'right', cursor: 'pointer' }}
            onClick={() => {
              setUseMobile(!useMobile);
            }}
          >
            {useMobile ? 'Use email instead' : 'Use mobile instead'}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {
            //<Typography sx={classes(theme).inputLabels}>Password</Typography>
          }
          <OutlinedInput
            fullWidth
            size="small"
            placeholder="Password"
            type={showPassword ? 'text' : 'password'}
            onChange={(e) => {
              setShowPasswordText(true);
              setPassword(e.target.value.trim());
            }}
            name="password"
            value={password}
            // startAdornment={
            //   <InputAdornment position="start">
            //     <LockIcon style={{ fontSize: '15px', color: '#00695c' }} />
            //   </InputAdornment>
            // }
            // placeholder={('Enter Password')}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  sx={{ padding: '0' }}
                >
                  {showPassword ? (
                    <Visibility fontSize="small" />
                  ) : (
                    <VisibilityOff fontSize="small" />
                  )}
                </IconButton>
              </InputAdornment>
            }
          />
          {props.signupError && !!props.signupError.password && (
            <FormHelperText id="password-text">
              {props.signupError.password}
            </FormHelperText>
          )}
          {showPasswordText && (
            <Typography
              variant="caption"
              display="block"
              color={'primary'}
              gutterBottom
            >
              <Typography variant="caption" color={colorOne}>
                Atleast one uppercase
              </Typography>
              ,
              <Typography variant="caption" color={colorTwo}>
                {' '}
                one lowercase alphabets
              </Typography>
              <Typography variant="caption" color={colorThree}>
                {' '}
                and one number or special character.{' '}
              </Typography>
              <Typography variant="caption" color={colorFour}>
                And 6 or more in length
              </Typography>
            </Typography>
          )}
        </Grid>
        <Grid item xs={12}>
          <Box justifyContent="center" display="flex">
            <ColoredButton
              style={{
                width: '100%',
                borderRadius: '20px',
                boxShadow: '0px 3px 8px rgb(130,177,255,0.5)',
              }}
              loading={loading}
              disabled={isInvalid || loading}
              type="submit"
              variant="contained"
              bgcolor={red}
              disableElevation
            >
              {siteRoles[props.occupation - 1] &&
              siteRoles[props.occupation - 1]['name']
                ? `Sign up as ${siteRoles[props.occupation - 1]['name']}`
                : 'Sign Up'}
            </ColoredButton>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle2">
            By signing up, you agree to the{' '}
            <Link
              underline="hover"
              component={RouterLink}
              to={{ pathname: ROUTES.PRIVACY, state: { from: props.location } }}
            >
              Our Privacy Policy
            </Link>{' '}
            and{' '}
            <Link
              underline="hover"
              component={RouterLink}
              to={{ pathname: ROUTES.TNC, state: { from: props.location } }}
            >
              Terms of Services
            </Link>
            .
          </Typography>
        </Grid>
      </Grid>
      {error && <p>{error.message}</p>}
    </Box>
  );
};

const SignUpLink = (props) => (
  <Box>
    <Typography>
      <p>
        {'Dont have an account?'}{' '}
        <Link
          style={{ color: '#2196f3' }}
          component={RouterLink}
          to={{ pathname: ROUTES.SIGN_UP, state: { from: props.location } }}
        >
          {'Sign Up'}
        </Link>
      </p>
    </Typography>
    <Typography>
      <p>
        {'Forgot your password?'}{' '}
        <Link
          style={{ color: '#2196f3' }}
          component={RouterLink}
          to={{
            pathname: ROUTES.PASSWORD_FORGOT,
            state: { from: props.location },
          }}
        >
          {'Email Reset Link'}
        </Link>
      </p>
    </Typography>
  </Box>
);

const SignUpGoogleBase = (props) => {
  const onSubmit = (event) => {
    props.dispatchDestroySession();
    event.preventDefault();
    props.dispatchRegisterType('Google');

    const provider = new GoogleAuthProvider();
    provider.addScope('email');

    signInWithRedirect(props.auth, provider, browserPopupRedirectResolver);
  };

  return (
    <form onSubmit={onSubmit}>
      <IconButton type="submit" aria-label="google">
        <Icon component="img" fontSize="large" src={GoogleSVGIcon} />
      </IconButton>
    </form>
  );
};

const SignUpFacebookBase = (props) => {
  const onSubmit = (event) => {
    props.dispatchDestroySession();
    event.preventDefault();
    props.dispatchRegisterType('Facebook');

    const provider = new FacebookAuthProvider();
    provider.addScope('email');

    signInWithRedirect(props.auth, provider, browserPopupRedirectResolver);
  };

  return (
    <form onSubmit={onSubmit}>
      <IconButton type="submit" aria-label="facebook">
        <Icon component="img" fontSize="large" src={FacebookSVGIcon} />
      </IconButton>
    </form>
  );
};

const SignUpTwitterBase = (props) => {
  const onSubmit = (event) => {
    props.dispatchDestroySession();
    event.preventDefault();
    props.dispatchRegisterType('Twitter');

    const provider = new TwitterAuthProvider();
    provider.addScope('email');

    signInWithRedirect(props.auth, provider, browserPopupRedirectResolver);
  };

  return (
    <form onSubmit={onSubmit}>
      <SocialMediaButton type="submit" variant="contained" size="medium">
        <Icon>
          <img style={{ width: '20px' }} src={TwitterSVGIcon} />
        </Icon>
      </SocialMediaButton>
    </form>
  );
};

const mapStateToProps = (state) => ({
  occupation: state.register.occupation,
  signupError: state.register.errors,
  signupWith: state.register.signupWith,
  email: state.register.email,
  mobile: state.register.mobile,
  referer: state.common.siteReferrer,
  initVars: state.common.initVars,
});

const mapDispatchToProps = {
  signupUser,
  signupFirebaseUser,
  signupUserWithMobile,
  loginFirebaseUser,
  resetErrorsDispatch,
  sendSignupOTP,
  sendSignupMobileOTP,
  fetchInitVars,
  dispatchSetOccupation,
  dispatchDestroySession,
  dispatchRegisterType,
};

const SignUpForm = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SignUpFormBase),
);

const SignUpGoogle = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SignUpGoogleBase),
);

const SignUpFacebook = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SignUpFacebookBase),
);

const SignUpTwitter = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SignUpTwitterBase),
);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SignUpPage),
);

export { SignUpLink };
